
import React from "react";
import { Button, ScrollView, StyleSheet, TouchableOpacity } from "react-native";
import { TargetConcerns } from "../components/TargetConcerns";
import { YourIngredients } from "../components/YourIngredients";
import { EnviromentalFactors } from "../components/EnviromentalFactors";
import { View, Text, Alert } from "react-native";
import Logo from '../../assets/Logo.png'
import { AdvicePage } from "../components/AdvicePage";
import { IngredientImage } from "../components/ingredientImage";
import { useParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';


export function ResultsPage() {


  const [ingredients, setIngredients] = useState([])


  const [id, setId] = useState('');
  const [name, setName] = useState('Retrieving your personalized skin care');
  const [niacinamide, setNiacinamide] = useState(0);
  const [ascorbicAcid, setAscorbicAcid] = useState(0);
  const [retinol, setRetinol] = useState(0);
  const [oatExtract, setOatExtract] = useState(0);
  const [hyaluronicAcid, setHyaluronicAcid] = useState(0);
  const [targetConcerns, setTargetConcerns] = useState([]);
  const [humidity, setHumidity] = useState('');
  const [seasonalWeather, setSeasonalWeather] = useState('');
  const [uv, setUv] = useState('');
  const [airPollution, setAirPollution] = useState('');

  const navigate = useNavigate();

  const { resultId } = useParams();

  useEffect(() => {
    // fetch('https://adapted-backend.herokuapp.com/getResults/' + resultId, {
      fetch('https://adapted-backend.herokuapp.com/getResults/' + resultId, {
      headers: {
        "Accept": "*/*",
        "Content-Type": "application/json",
        "Connection": "keep-alive"
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Request failed');
        }
        return response.json();
      })
      .then(data => {
        console.log(data)
        let resultData = data[0];
        setId(resultData[0]);
        setName(resultData[1]);
        setHumidity(resultData[8])
        setSeasonalWeather(resultData[9])
        setUv(resultData[10])
        setTargetConcerns(resultData[7].split(","));

        const allIngredients = ["niacinamide", "ascorbic", "retinol", "oatExtract", "hyaluronic"];
        const counts = [resultData[2], resultData[3], resultData[4], resultData[5], resultData[6]];
        const ingredientsToAdd = counts.reduce((arr, count, index) => {
          if (count > 0) {
            return [...arr, allIngredients[index]];
          }
          return arr;
        }, []);
        setIngredients(ingredientsToAdd);
      })
      .catch(error => {
        console.error(error);
      });
  }, [resultId]);

  const handleSubmit = () => {
    console.log('added to email')
  };

  return (
    <View style={styles.pageContainer}>
      <ScrollView
        contentContainerStyle={styles.scrollViewContent}
        showsHorizontalScrollIndicator={true}
        horizontal={false}
        scrollIndicatorInsets={{ right: 10, top: 10, bottom: 10, left: 10 }}
        
      >
        <View style={styles.imageContainer}>
          <img src={Logo} style={styles.image} />
        </View>

        <View style={styles.intro}>
          <Text style={styles.introText}>
            {name}, say hello to your{' '}
            <Text style={{ fontWeight: 'bold' }}>personalized skin care</Text>
          </Text>
        </View>

        <View style={styles.proven}>
          <Text style={styles.introText}>This skin care routine has been developed to specifically address your unique needs and goals using ingredients proven to protect and rejuvenate skin.</Text>
        </View>

        {humidity !== '' && (
          <>
        <View style={styles.ingredientContainer}>
          <Text style={styles.yourIngredients}>Key Ingredients</Text>
          <View style={styles.ingredientImages}>
            {ingredients.map((ingredient, index) => (
              <IngredientImage key={index} ingredient={ingredient} />
            ))}
          </View>
        </View>

        <View style={styles.TargetConcerns}>
          <TargetConcerns targetConcerns={targetConcerns} />
        </View>

        <View style={styles.EnvironmentalFactors}>
          <EnviromentalFactors humidity={humidity} seasonalWeather={seasonalWeather} uvExposure={uv} />
        </View>

        <View style={styles.proven}>
          <Text style={styles.introText}>Each of your personalized sheet masks feature powerful ingredients chosen for the compatibility with your skin type, environmental factors, needs and goals. Your personalized routine features a combination of these ingredient formulations designed for an effective and easy-to-follow 60 day routine.</Text>
        </View>
        <View>
          <TouchableOpacity
            style={[
              styles.actionButton]}
            onPress={() => handleSubmit()}
          >
            <Text style={styles.actionText}>Join the product waitlist</Text>
          </TouchableOpacity>
        </View>

        <View style={styles.advicePage}>
          <AdvicePage humidity={humidity}></AdvicePage>
        </View>
        </>
        )}
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  pageContainer: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  scrollViewContent: {
    flex: 1,
    width: '100%',
    height: '100%',
  },
  imageContainer: {
    //display: 'flex',
    height: 100,
    width: 150,
    alignItems: 'center',
    marginTop: 10,
    left: '50%',
    transform: 'translateX(-50%)',
    //width: '50%',
  },
  image: {
    //position: 'fixed',
    top: 0,
    height: '100%',
    width: '100%'
    //padding: 30,
  },
  intro: {
    display: 'flex',
    alignItems: 'center',
    display: 'flex',
    marginTop: 45,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '80%',

  },
  introText: {
    color: '#3B1C15',
    fontSize: 25,
    textAlign: 'center',
    fontFamily: 'DM Sans',
    padding: 10,
    fontWeight: 400,
    overflow: 'visible'
  },
  proven: {
    display: 'flex',
    alignItems: 'center',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '80%',
  },
  faceMask: {
    marginTop: 10,
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'center',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '80%',
    padding: 10
  },
  faceMaskText: {
    fontFamily: 'DM Sans',
    fontSize: 25,
    color: '#3B1C15',
    marginTop: 10,
    marginBottom: 5,
    textAlign: 'center'
  },
  TargetConcerns: {
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    marginTop: 10,
    backgroundColor: '#EFE5DA',
    justifyContent: 'center',
    alignItems: 'center',
    width: '80%',
    height: 'fit-content',
  },
  EnvironmentalFactors: {
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    marginTop: 10,
    backgroundColor: '#EFE5DA',
    justifyContent: 'center',
    alignItems: 'center',
    width: '80%',
    overflow: 'visible',
    height: 'fit-content',
  },
  ingredientContainer: {
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    //marginTop: 10,
    backgroundColor: '#EFE5DA',
    justifyContent: 'center',
    alignItems: 'center',
    width: '80%',
    height: 'fit-content',
  },
  yourIngredients: {
    fontFamily: 'DM Serif Display',
    fontSize: 30,
    fontWeight: 'bold',
    color: '#3B1C15',
    //marginBottom: 5,
  },
  ingredientImages: {
    width: '100%',
    flexDirection: 'row',
    marginTop: 10,
    //alignItems: 'center',
    padding: 0,
    justifyContent: 'space-around',
    flexWrap: 'wrap'
  },
  advicePage: {
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    marginTop: 10,
    justifyContent: 'center',
    alignItems: 'center',
    width: '90%',
    height: 'fit-content',
  },
  actionButton: {
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#9EA698',
    width: 300,
    height: 82,
    padding: 10

  },
  actionText: {
    fontFamily: 'DM Serif Display',
    fontSize: 30,
    color: '#FFFFFF',
    textAlign: 'center',
    fontWeight: '400',
  },
});
